

















































































import {
  ref,
  toRefs,
  computed,
  PropType,
  defineComponent,
  getCurrentInstance,
  ComponentInternalInstance,
  watch,
} from 'vue-demi';
import ErrorHint from './errorHint.vue';
import { NativeMaterialInfo, NativeMaterialStatus } from './../../enums/media';
import { SelfServeTiktokPostMobile } from '@ad/self-serve-sdk-vue';
import PopupVideoPreview from '@/components/popup/popup-video-preview.vue';
import InfiniteLoading from 'vue-infinite-loading';
import identityStore from './../../store/modules/identity/index';
import { useIdentityHooks } from './../../hooks/global/useIdentityHooks';

const name = 'TikTokPostContainer';
export default defineComponent({
  name,
  components: {
    ErrorHint,
    PopupVideoPreview,
    SelfServeTiktokPostMobile,
    InfiniteLoading,
  },
  props: {
    displayName: {
      type: String,
      default: '',
    },
    avatarUrl: {
      type: String,
      default: '',
    },
    identityNotAvailable: {
      type: Boolean,
      default: false,
    },
    videoList: {
      type: Array as PropType<Array<NativeMaterialInfo>>,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    preLoadVid: {
      type: String,
      default: '',
    },
    loadingConfirm: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const componentName = 'tiktok-video-container';
    const { proxy: _this } = getCurrentInstance() as ComponentInternalInstance;
    const { curIdentity } = useIdentityHooks();
    const { videoList, identityNotAvailable, loadingConfirm, preLoadVid } = toRefs(props);
    const showVideoPlayer = ref(false);
    const videoUrl = ref('');
    const videoIds = computed(() => videoList.value.map(item => item.video_info.vid));

    const currentSelection = ref('');
    watch(preLoadVid, () => {
      currentSelection.value = '';
    });
    const isSelectedIdInVideoList = computed(() => videoIds.value.includes(currentSelection.value));
    const hintMessage = ref(_this.$t(''));
    const showHint = ref(false);
    const showConfirm = computed(() => currentSelection.value.length > 0);
    const closeHint = () => {
      showHint.value = false;
      hintMessage.value = _this.$t('');
    };
    const checkVideo = vid => {
      currentSelection.value = vid === currentSelection.value ? '' : vid;
    };
    const handleErrorStage = vid => {
      const selectedVideo = videoList.value.filter(item => item.video_info.vid === vid);
      if (identityNotAvailable.value) {
        showHint.value = true;
        hintMessage.value = _this.$t('fastcreation_identity_invalid_desc');
        return;
      }
      if (selectedVideo[0]?.status !== NativeMaterialStatus.AUTHORIZED) {
        showHint.value = true;
        hintMessage.value = _this.$t('fastcreation_media_ttvideo_unauthorized_hint');
      }
    };
    const onScrollToBottom = async $state => {
      const { identity_type, identity_id } = curIdentity?.value;

      await identityStore.actions.getNativeMaterialList(identity_type, identity_id);
      if (identityStore.getters.identityFormData.value.nativeVideoHasMore) {
        $state.loaded();
      } else {
        $state.complete();
      }
    };
    const handleSelection = () => {
      const selectedVideo = videoList.value.filter(item => item.video_info.vid === currentSelection.value);
      emit('select-tiktok-post', selectedVideo[0]);
    };
    const handleIdentitySelect = () => {
      if (loadingConfirm.value) {
        return;
      }
      emit('show-identity-selection');
    };
    const handleVideoPlay = vid => {
      const selectedVideo = videoList.value.filter(item => item.video_info.vid === vid);
      showVideoPlayer.value = true;
      videoUrl.value = selectedVideo[0].video_info.play_url;
    };
    return {
      showHint,
      closeHint,
      checkVideo,
      videoUrl,
      hintMessage,
      showConfirm,
      componentName,
      showVideoPlayer,
      handleSelection,
      currentSelection,
      handleErrorStage,
      handleVideoPlay,
      handleIdentitySelect,
      isSelectedIdInVideoList,
      onScrollToBottom,
    };
  },
});
